class SubnavAnimation {
  constructor() {
    this.navbar = document.querySelector('.navbar')
    this.primarylinks = this.navbar.querySelector('.primary-links')
    this.navItems = this.primarylinks.querySelectorAll('.mega-menu-item')
    this.navItemsL = this.navItems.length
    this.subnav = this.navbar.querySelectorAll('.mega-menu-flyout')
    this.subnavBackground = document.querySelector('.mega-menu-subnav-placeholder')
    this.subnavCurtain = document.querySelector('.mega-menu-subnav-curtain')

    this.itemHovered = false
    this.anchorHovered = false
    
    this.init()
  }

  init = () => {
    this.initSubnav()
  }

  getAutoHeightDuration = (height) => {
    if (!height) {
      return 0
    }

    const constant = height / 36

    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10)
  }

  initSubnav = () => {
    this.navItems.forEach((item, index) => {
      const links = item.querySelector('.li-inner')
      links.addEventListener('mousemove', () => this.onAnchorHover(item))
      item.addEventListener('mousemove',  this.onItemHoverIn)
      item.addEventListener('mouseleave', this.onItemHoverOut)
    })
  }

  onAnchorHover = (item) => {
    this.anchorHovered = true

    if (this.itemHovered && this.anchorHovered) {
      const contentHeight = item.querySelector('.mega-menu-flyout-container').offsetHeight
      const duration = this.getAutoHeightDuration(contentHeight)
      this.navbar.style.setProperty('--subnav-transition-rate', (duration + 50) + 'ms')

      this.removeLinkHoveredClass()
      item.classList.add('is-hovered')

      this.navbar.classList.add('navbar-with-subnav-open')

      this.subnavBackground.style.height = `${contentHeight}px` 
    }
  }

  closeSubnav = () => {
    if (!this.itemHovered && !this.anchorHovered) {
      this.removeLinkHoveredClass()

      this.navbar.classList.remove('navbar-with-subnav-open')
    }
  }

  removeLinkHoveredClass = () => {
    const hoveredItem = document.querySelector('.mega-menu-item.is-hovered')

    if (hoveredItem) {
      hoveredItem.classList.remove('is-hovered')
    }
  }


  onItemHoverIn = () => {
    this.itemHovered = true
  }

  onItemHoverOut = () => {
    this.itemHovered = false
    this.anchorHovered = false

    setTimeout(() => {
      if (!this.itemHovered || !this.anchorHovered) {
        this.closeSubnav()
      }
    }, 100)
  }
}
const observer = new MutationObserver((mutations, obs) => {
  const navbarLinks = document.querySelectorAll('.mega-menu-item .li-inner');
  if (navbarLinks.length>=4) {
    new SubnavAnimation();
    obs.disconnect(); // Stop observing once the navbar is found
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});